import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import ConfirmationModal from '../../ConfirmationModal';
import { GlobalButton } from '@/components';
import { useState } from 'react';
import {
  AssignmentTurnedIn as AssignmentTurnedInIcon,
  CheckCircle as CheckIcon,
  WarningAmber as WarningIcon,
} from '@mui/icons-material';

interface CloseReturnsIntakesActionProps {
  onFinish: () => Promise<void>;
  onGoToStart: () => void;
  isProcessing: boolean;
  driverName: string;
}

const CloseReturnsIntakesAction = ({
  onFinish,
  onGoToStart,
  isProcessing,
  driverName,
}: CloseReturnsIntakesActionProps) => {
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const handleOpenConfirm = () => setIsConfirmModalOpen(true);
  const handleCloseConfirm = () => setIsConfirmModalOpen(false);

  const handleConfirmFinish = async () => {
    handleCloseConfirm();
    await onFinish();
  };

  return (
    <>
      <div className='w-full sticky bottom-0 z-10 bg-white rounded-2xl border border-gray-200 py-4 px-6 shadow-[0_-8px_30px_-10px_rgba(0,0,0,0.1)] transition-all'>
        <div className='flex justify-end gap-4'>
          <GlobalButton
            variant={GlobalButtonVariant.secondaryButton}
            action={onGoToStart}
            disabled={isProcessing}
            size='large'
          >
            Volver al inicio
          </GlobalButton>
          <GlobalButton
            variant={GlobalButtonVariant.primaryButton}
            action={handleOpenConfirm}
            disabled={isProcessing}
            size='large'
          >
            <CheckIcon className='mr-2 text-[20px]' />
            Cerrar Rendición
          </GlobalButton>
        </div>
      </div>

      <ConfirmationModal
        open={isConfirmModalOpen}
        onClose={handleCloseConfirm}
        onConfirm={handleConfirmFinish}
        title='Cerrar Rendición del Conductor'
        icon={AssignmentTurnedInIcon}
        confirmLabel='Cerrar Rendición'
        description={
          <>
            ¿Está seguro de que desea cerrar la rendición del conductor
            <span className='font-black text-gray-800'> {driverName}</span>?
            <div className='flex items-center gap-4 p-5 rounded-xl bg-orange-50 border border-orange-200 mt-4 mb-2'>
              <div className='text-orange-600 shrink-0'>
                <WarningIcon sx={{ fontSize: 28 }} />
              </div>
              <p className='text-orange-900 text-[14px] leading-relaxed'>
                Esta acción cerrará la rendición actual del conductor. Se
                procesarán <strong>todos los pedidos</strong> que figuran en
                este resumen.
              </p>
            </div>
          </>
        }
        isProcessing={isProcessing}
      />
    </>
  );
};

export default CloseReturnsIntakesAction;
